import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import { t } from '../../i18n/i18n';
import ModalCustom from '../ModalCustom/ModalCustom';

export const ModalReminderToCandidateEnabled = ({
  showModal,
  setShowModal,
  data: { reminderToCandidates },
  submitAction,
  disabledButtonProps = false,
}) => {
  const [disabledButton, setDisabledButton] = useState(false);
  const onClickButton = () => {
    setDisabledButton(true);
    submitAction();
  };
  return (
    <>
      <ModalCustom
        onCancel={() => setShowModal(false)}
        onCancelText={t('CANCEL_OPERATION_LABEL')}
        onOk={disabledButtonProps && disabledButton ? () => {} : onClickButton}
        classModal="allow-certificate-download-modal-width"
        subtitleClassName="px-0 px-lg-0"
        onOkText={reminderToCandidates ? t('DEACTIVATE_LABEL') : t('ACTIVATE_LABEL')}
        setShow={setShowModal}
        show={showModal}
        title={
          reminderToCandidates
            ? t('WILL_DISABLE_REMINDER_TO_CANDIDATES')
            : t('WILL_ENABLE_REMINDER_TO_CANDIDATES')
        }
        subtitle={
          reminderToCandidates
            ? t('TO_DISABLE_REMINDER_TO_CANDIDATES_DESCRIPTION_MODAL')
            : t('TO_ENABLE_REMINDER_TO_CANDIDATES_DESCRIPTION_MODAL')
        }
      />
    </>
  );
};
